export default function Contact() {
  return (
    <section id="contato" className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Entre em Contato
            </h2>
            <p className="text-xl text-gray-600">
              Estamos prontos para ajudá-lo em sua jornada ministerial
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg p-8 shadow-lg">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                Informações de Contato
              </h3>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center shrink-0">
                    <i className="ri-whatsapp-line text-teal-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">WhatsApp</h4>
                    <a
                      href="https://wa.me/5567992870208"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-teal-600 hover:text-teal-700 text-lg font-medium cursor-pointer"
                    >
                      (67) 99287-0208
                    </a>
                    <p className="text-sm text-gray-600 mt-1">
                      Disponível para atendimento
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center shrink-0">
                    <i className="ri-map-pin-line text-teal-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Localização</h4>
                    <p className="text-gray-600">
                      Mato Grosso do Sul, Brasil
                    </p>
                    <p className="text-sm text-gray-600 mt-1">
                      Atendimento presencial e online
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center shrink-0">
                    <i className="ri-time-line text-teal-600 text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Horário de Atendimento</h4>
                    <p className="text-gray-600">
                      Segunda a Sexta: 8h - 18h
                    </p>
                    <p className="text-gray-600">
                      Sábado: 9h - 13h
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-200">
                <h4 className="font-bold text-gray-900 mb-4">
                  Por que escolher o ICMI?
                </h4>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-gray-700">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>Mais de 25 anos de experiência</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-700">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>300+ alunos formados</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-700">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>Certificação reconhecida</span>
                  </li>
                  <li className="flex items-center gap-3 text-gray-700">
                    <i className="ri-check-line text-teal-600 text-xl"></i>
                    <span>Modalidade presencial e online</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-lg p-8 shadow-lg text-white">
              <h3 className="text-2xl font-bold mb-6">
                Inicie sua Formação Hoje
              </h3>
              
              <p className="text-teal-50 mb-8 leading-relaxed">
                Entre em contato conosco pelo WhatsApp e receba todas as informações sobre nossos cursos, mentorias, valores e formas de pagamento. Nossa equipe está pronta para ajudá-lo a escolher o melhor caminho para seu desenvolvimento ministerial.
              </p>

              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6 mb-8 border border-white/20">
                <h4 className="font-bold mb-4 text-lg">O que você receberá:</h4>
                <ul className="space-y-3">
                  <li className="flex items-center gap-3">
                    <i className="ri-check-double-line text-teal-300 text-xl"></i>
                    <span>Informações detalhadas sobre os cursos</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="ri-check-double-line text-teal-300 text-xl"></i>
                    <span>Orientação sobre a melhor opção para você</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="ri-check-double-line text-teal-300 text-xl"></i>
                    <span>Valores e formas de pagamento</span>
                  </li>
                  <li className="flex items-center gap-3">
                    <i className="ri-check-double-line text-teal-300 text-xl"></i>
                    <span>Datas de início das turmas</span>
                  </li>
                </ul>
              </div>

              <a
                href="https://wa.me/5567992870208"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 w-full bg-white text-teal-600 py-4 rounded-lg text-lg font-bold hover:bg-teal-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                Falar com Consultor
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
